import type { NavigationContext } from '@/src/lib/navigation';

export interface MobileNavItem {
  id: string;
  label: string;
  shortLabel: string;
  href: string;
  context: NavigationContext;
  icon: string;
}

export const MOBILE_NAV_ITEMS: readonly MobileNavItem[] = [
  { id: 'dashboard', label: 'Übersicht', shortLabel: 'Home', href: '/dashboard', context: 'overview', icon: 'D' },
  { id: 'operations', label: 'Operativ', shortLabel: 'Operativ', href: '/dashboard?ctx=operations', context: 'operations', icon: 'O' },
  { id: 'accounting', label: 'Buchhaltung', shortLabel: 'Buchhaltung', href: '/reports?ctx=accounting', context: 'accounting', icon: 'B' },
  { id: 'advisor', label: 'Berater', shortLabel: 'Berater', href: '/steuerberater', context: 'advisor', icon: 'S' },
  { id: 'tenant', label: 'Mandant', shortLabel: 'Mandant', href: '/einstellungen/mandant', context: 'tenant', icon: 'M' },
] as const;

export function getMobileNavItemForContext(context: NavigationContext): MobileNavItem | undefined {
  return MOBILE_NAV_ITEMS.find((item) => item.context === context);
}
